/** Mirrors backend PortalPostVisibility / PortalPostStatus (ordinal ignore-case). */

export const PORTAL_POST_STATUS = {
  Draft: 'Draft',
  Published: 'Published',
  Scheduled: 'Scheduled',
  Private: 'Private',
  PasswordProtected: 'PasswordProtected',
};

const statusEq = (status, expected) =>
  String(status || '').localeCompare(expected, undefined, { sensitivity: 'accent' }) === 0;

export function isPubliclyListed(status, scheduledAt, utcNow = new Date()) {
  if (statusEq(status, PORTAL_POST_STATUS.Published)) return true;
  if (statusEq(status, PORTAL_POST_STATUS.PasswordProtected)) return true;
  if (statusEq(status, PORTAL_POST_STATUS.Scheduled) && scheduledAt) {
    const when = scheduledAt instanceof Date ? scheduledAt : new Date(scheduledAt);
    return !Number.isNaN(when.getTime()) && when.getTime() <= utcNow.getTime();
  }
  return false;
}

export function bodyRequiresPassword(status) {
  return statusEq(status, PORTAL_POST_STATUS.PasswordProtected);
}

export function isDueScheduled(status, scheduledAt, utcNow = new Date()) {
  if (!statusEq(status, PORTAL_POST_STATUS.Scheduled) || !scheduledAt) return false;
  const when = scheduledAt instanceof Date ? scheduledAt : new Date(scheduledAt);
  return !Number.isNaN(when.getTime()) && when.getTime() <= utcNow.getTime();
}

/**
 * Anonymous payload flags — mirrors PortalPublicController list/detail/unlock.
 * Media (featured + attachments) is only presigned when the body is included.
 */
export function anonymousPostAccess({
  status,
  scheduledAt,
  unlocked = false,
  utcNow = new Date(),
} = {}) {
  const listed = isPubliclyListed(status, scheduledAt, utcNow);
  const needsPassword = bodyRequiresPassword(status);
  const includeBody = listed && (!needsPassword || unlocked);
  return {
    listed,
    needsPassword,
    includeBody,
    includeFeaturedMedia: includeBody,
    includeAttachments: includeBody,
  };
}
